<div class="qa--item" [class.qa--item__active]="active">
  {{ faq.title | translate }}
</div>
